<!-- 筛选项(默认标题在左，通体灰色，无边框) -->
<template>
  <div class="ai-condition">
    <!-- 前缀图标 -->
    <i v-if="prefix" class="t-iconfont" :class="prefix" />
    <!-- 标题 -->
    <span v-if="label" class="ai-condition__label">{{ label }}</span>

    <!-- 内容 -->
    <div class="ai-condition__content" :style="{ width: contentWidth }">
      <el-select
        v-if="!$slots.content"
        v-model="modelValue"
        :clearable="clearable"
        :filterable="filterable"
        placeholder="请选择"
        @change="handleChange"
      >
        <el-option
          v-for="item in options"
          :key="item[labelValue.value]"
          :label="item[labelValue.label]"
          :value="item[labelValue.value]"
        />
      </el-select>
      <!-- 内容插槽 -->
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

defineOptions({
  name: 'AiCondition'
})

const emits = defineEmits(['change', 'update:value'])
const props = defineProps({
  // 前缀图标
  prefix: {
    type: String,
    default: ''
  },
  // 标题
  label: {
    type: String,
    default: ''
  },
  // 选项列表
  options: {
    type: Array,
    default: () => []
  },
  // 选项绑定的标题和值
  labelValue: {
    type: Object,
    default: () => ({
      label: 'name',
      value: 'id'
    })
  },
  // 选中值
  value: {
    type: [String, Number],
    default: ''
  },
  // 是否显示清除按钮
  clearable: {
    type: Boolean,
    default: true
  },
  // 是否可前端搜索过滤
  filterable: {
    type: Boolean,
    default: true
  }
})

// 本地选中值
const modelValue = computed({
  get: () => props.value,
  set: (val) => emits('update:value', val)
})
// 筛选项主体内容宽度
const contentWidth = computed(() => {
  const paddingMargin = '36px'
  const labelWidth = props.showLabel ? '60px' : '0px'

  return `calc(100% - ${paddingMargin} - ${labelWidth})`
})

/**
 * 选中值变化的回调
 * @param val 选择的值
 */
const handleChange = (val) => {
  emits('change', val)
}
</script>

<style lang="scss" scoped>
.ai-condition {
  display: flex;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  height: 36px;
  padding: 6px 12px;
  align-self: stretch;
  border-radius: 8px;
  background: #f7f8fa;
  z-index: 2;

  .t-iconfont {
    height: 16px;
  }

  &__label {
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: normal;
    line-height: normal;
    text-align: center;
    letter-spacing: 0em;
    color: #969799;
    min-width: 60px;
    margin-right: 12px;
    white-space: nowrap;
  }

  &__content {
    flex: 1;
    overflow: hidden;
  }

  :deep(.customer-select > .el-select),
  :deep(.customer-template-select > .el-select),
  :deep(.customer-stage-select > .el-select),
  :deep(.user-select .el-input),
  :deep(.department-select-box) {
    width: 100%;
  }
  :deep(.department-staff-select-box),
  :deep(.customer-select .customer-select__dropdown) {
    padding: 6px 8px;
  }
  :deep(.department-staff-select-box),
  :deep(.customer-select .customer-select__dropdown),
  :deep(.department-select-box),
  :deep(.el-input__wrapper),
  :deep(.el-select__wrapper) {
    background: transparent;
  }
  :deep(.el-cascader):not(.is-disabled):hover .el-input__wrapper,
  :deep(.el-cascader) .el-input.is-focus .el-input__wrapper,
  :deep(.el-date-editor.el-input__wrapper:hover),
  :deep(.el-input__wrapper),
  :deep(.el-select__wrapper) {
    padding: 0;
    box-shadow: none !important;
  }
  :deep(.department-select-box) {
    padding: 2px 0;
    border: 0;
  }
  :deep(.el-input__wrapper) {
    min-height: unset;
    height: 100%;
  }
  :deep(.el-cascader__tags) {
    display: flex;
    flex-wrap: nowrap;
    overflow: hidden;
  }
}
</style>
